






























































import { Schedule, ScheduleSeason } from '@bookings/interfaces/schedule';
import { Vue, Component, Prop } from 'vue-property-decorator';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import ScheduleService, { useScheduleService } from '@bookings/services/schedule-service';
import BpcScheduleSeasonForm from './schedule-season-form.vue';
import { AxiosError } from 'axios';
@Component({
  name: 'bpc-schedule-season-input-list',
  components: {
    BpcDrawerModal,
    BpcScheduleSeasonForm,
  },
})
export default class ScheduleSeasonInputList extends Vue {
  $refs: {
    scheduleSeasonForm: InstanceType<typeof BpcScheduleSeasonForm> & {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      manageSaveErrors(errors: any): void;
    };
  };
  @Prop({
    type: Array,
    default() {
      return [];
    },
  })
  readonly scheduleSeasons: ScheduleSeason[];
  @Prop({
    type: Object,
  })
  readonly schedule: Schedule;

  disabledForm = false;
  modalTitle = this.$t('global.season.modal.title');
  isSavingForm = false;
  showScheduleSeasonForm = false;
  srv: ScheduleService = null;
  seasonFormModel: ScheduleSeason = null;
  selectedSeason: ScheduleSeason = null;

  created() {
    this.srv = useScheduleService();
  }

  async onFormSave() {
    try {
      if (this.seasonFormModel.id) {
        await this.srv.updateScheduleSeason(this.schedule.id, this.seasonFormModel);
      } else {
        await this.srv.createScheduleSeason(this.schedule.id, this.seasonFormModel);
      }
      this.$emit('schedule-seasons-changed');
      this.showScheduleSeasonForm = false;
    } catch (error) {
      const axiosError = error as AxiosError;
      this.$refs.scheduleSeasonForm.manageSaveErrors(axiosError?.response?.data?.errors || {});
    }
  }
  onFormClose() {
    // Add your logic here
    this.seasonFormModel = null;
    this.selectedSeason = null;
    this.showScheduleSeasonForm = false;
  }
  async editScheduleSeason(scheduleSeason: any) {
    // Add your logic here
    const newSchedule = await this.srv.updateSchedule(this.schedule.id, this.schedule);
    this.$emit('schedule-updated', newSchedule);
    this.selectedSeason = scheduleSeason;
    this.showScheduleSeasonForm = true;
  }
  cloneScheduleSeason(scheduleSeason: any) {
    console.log('Clone Schedule Season', scheduleSeason);
  }
  async removeScheduleSeason(scheduleSeason: any) {
    // TODO show a confirmation modal
    await this.srv.removeScheduleSeason(this.schedule.id, scheduleSeason.id);
    this.$emit('schedule-seasons-changed');
  }
  async addNewScheduleSeason() {
    this.seasonFormModel = await this.srv.getScheduleSeasonNewModel(this.schedule.id);
    this.showScheduleSeasonForm = true;
  }
}
